module.exports = __webpack_public_path__ + "static/img/index10.48cae63.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index10.gif
// module id = WxK/
// module chunks = 0